function Navbar({ title}) {  //title acts as props here
    return (
        <div className="navbar">
            <h1>{title}</h1>
        </div>
    )
}

export default Navbar